import * as React from "react";
import type { UserNotifications } from "~/config/user/user-notifications/utils/types";
import type { Filters } from "../../UserNotificationsScreen";
import { NotificationsList } from "./components/NotificationsList";

type NotificationsContentProps = {
  notifications?: UserNotifications;
  setFilters: React.Dispatch<React.SetStateAction<Filters>>;
  filters: Filters;
  defaultFilters?: Filters;
  fetchMore?: () => void;
};

const NotificationsContent = (props: NotificationsContentProps) => (
  <NotificationsList
    defaultFilters={props.defaultFilters}
    notifications={props.notifications}
    setFilters={props.setFilters}
    filters={props.filters}
    fetchMore={props.fetchMore}
  />
);

export { NotificationsContent };
